import config from '../nuxt.config.js';

var createHeader = function (attrs) {
    let defaultHeader = config.head();

    if (!attrs) attrs = {};
    let title = attrs.title || defaultHeader.title;
    let description = attrs.description || defaultHeader.meta[0].content;
    let imageUrl = attrs.imageUrl || "https://stl-viewer.dualbox.com/img/socialmedia.webp";

    return {
        title: attrs.title,
        meta: [{
            hid: 'description',
            name: 'description',
            content: description
        }, {
            hid: 'og:title',
            name: 'og:title',
            content: title
        }, {
            hid: 'og:description',
            name: 'og:description',
            content: description
        }, {
            hid: 'og:image',
            name: 'og:image',
            content: imageUrl
        }, {
            hid: 'twitter:title',
            name: 'twitter:title',
            content: title
        }, {
            hid: 'twitter:description',
            name: 'twitter:description',
            content: description
        }, {
            hid: 'twitter:image',
            name: 'twitter:image',
            content: imageUrl
        }, {
            hid: 'twitter:card',
            name: 'twitter:card',
            content: 'summary_large_image'
        }],
    }
}

export default createHeader;